var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8C9.5 7.44772 9.94772 7 10.5 7H14.5C15.0523 7 15.5 7.44772 15.5 8C15.5 8.55228 15.0523 9 14.5 9H10.5C9.94772 9 9.5 8.55228 9.5 8Z",
    fill: "#1226AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11C9.94772 11 9.5 11.4477 9.5 12C9.5 12.5523 9.94772 13 10.5 13H14.5C15.0523 13 15.5 12.5523 15.5 12C15.5 11.4477 15.0523 11 14.5 11H10.5Z",
    fill: "#1226AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 2C6.54467 2 5.5 2.99492 5.5 4.22222V19.7778C5.5 21.0051 6.54467 22 7.83333 22H17.1667C18.4553 22 19.5 21.0051 19.5 19.7778V4.22222C19.5 2.99492 18.4553 2 17.1667 2H7.83333ZM7.5 4H17.5V20H15.5V16.7C15.5 16.0453 15.5 15.718 15.3526 15.4775C15.2702 15.3429 15.1571 15.2298 15.0225 15.1474C14.782 15 14.4547 15 13.8 15H11.2C10.5453 15 10.218 15 9.9775 15.1474C9.84295 15.2298 9.72982 15.3429 9.64736 15.4775C9.5 15.718 9.5 16.0453 9.5 16.7V20H7.5V4ZM11.5 20H13.5V17H11.5V20Z",
    fill: "#1226AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon_building.960f009c535a6ba60794a5d0e44d1b98.svg";
export { ForwardRef as ReactComponent };